import React from "react";
import { Link } from "react-router-dom";

interface AllUsersStatsProps {
    data: {
        total: number;
        by_status: {
            active: {
                total: number;
                paid: number;
                unpaid: number;
            };
            blocked: number;
            restricted: number;
            deleted: number;
        };
    };
}

export const AllUsersStats: React.FC<AllUsersStatsProps> = ({ data }) => {
    return (
        <div className="bg-white dark:bg-gray-800 shadow rounded-lg p-4">
            <h2 className="text-xl font-semibold mb-2 text-gray-900 dark:text-white">
                Все пользователи{" "}
                <small>
                    (
                    <Link
                        to="/dashboard/users"
                        className="text-blue-500 underline hover:text-blue-600"
                    >
                        Управление
                    </Link>
                    )
                </small>
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
                {/* Всего */}
                <Link
                    to="/dashboard/users"
                    className="p-4 rounded-md border border-gray-200 dark:border-gray-700 bg-blue-50 dark:bg-blue-900/20 hover:bg-blue-100 dark:hover:bg-blue-900/40 transition-colors cursor-pointer"
                >
                    <div className="text-sm text-gray-500 dark:text-gray-400">
                        Всего
                    </div>
                    <div className="text-2xl font-bold text-blue-600 dark:text-blue-400">
                        {data.total.toLocaleString()}
                    </div>
                </Link>

                {/* Активные */}
                <div className="p-4 rounded-md border border-gray-200 dark:border-gray-700 bg-green-50 dark:bg-green-900/20">
                    <Link
                        to="/dashboard/users?access_status=0"
                        className="hover:underline"
                    >
                        <div className="text-sm text-gray-500 dark:text-gray-400">
                            Активные
                        </div>
                        <div className="text-2xl font-bold text-green-600 dark:text-green-400">
                            {data.by_status.active.total.toLocaleString()}
                        </div>
                    </Link>
                    <div className="mt-2 text-xs space-y-1">
                        <Link
                            to="/dashboard/users?access_status=0&member_fee_filter=paid"
                            className="block text-green-700 dark:text-green-300 hover:underline"
                        >
                            Оплачено: {data.by_status.active.paid.toLocaleString()}
                        </Link>
                        <Link
                            to="/dashboard/users?access_status=0&member_fee_filter=overdue"
                            className="block text-orange-600 dark:text-orange-400 hover:underline"
                        >
                            Не оплачено: {data.by_status.active.unpaid.toLocaleString()}
                        </Link>
                    </div>
                </div>

                {/* Заблокированные */}
                <Link
                    to="/dashboard/users?access_status=1"
                    className="p-4 rounded-md border border-gray-200 dark:border-gray-700 bg-red-50 dark:bg-red-900/20 hover:bg-red-100 dark:hover:bg-red-900/40 transition-colors cursor-pointer"
                >
                    <div className="text-sm text-gray-500 dark:text-gray-400">
                        Заблокированы
                    </div>
                    <div className="text-2xl font-bold text-red-600 dark:text-red-400">
                        {data.by_status.blocked.toLocaleString()}
                    </div>
                </Link>

                {/* Ограниченные */}
                <Link
                    to="/dashboard/users?access_status=2"
                    className="p-4 rounded-md border border-gray-200 dark:border-gray-700 bg-yellow-50 dark:bg-yellow-900/20 hover:bg-yellow-100 dark:hover:bg-yellow-900/40 transition-colors cursor-pointer"
                >
                    <div className="text-sm text-gray-500 dark:text-gray-400">
                        Ограниченный доступ
                    </div>
                    <div className="text-2xl font-bold text-yellow-600 dark:text-yellow-400">
                        {data.by_status.restricted.toLocaleString()}
                    </div>
                </Link>

                {/* Удалённые */}
                <Link
                    to="/dashboard/users?access_status=3"
                    className="p-4 rounded-md border border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-700/50 hover:bg-gray-100 dark:hover:bg-gray-600/50 transition-colors cursor-pointer"
                >
                    <div className="text-sm text-gray-500 dark:text-gray-400">
                        Удалены
                    </div>
                    <div className="text-2xl font-bold text-gray-600 dark:text-gray-400">
                        {data.by_status.deleted.toLocaleString()}
                    </div>
                </Link>
            </div>
        </div>
    );
};
